import React from 'react';
import axios from 'Axios';
import { API_ROOT } from '../api/Routes';
import CriteriaGroup from 'src/components/demand/Demand/screens/CETicket/components/CriteriaGroup';
import CriteriaWrapper from 'src/components/demand/Demand/screens/CETicket/components/CriteriaWrapper';
import CriteriaWrapperColLeft from 'src/components/demand/Demand/screens/CETicket/components/CriteriaWrapperColLeft';
import CriteriaWrapperColRight from 'src/components/demand/Demand/screens/CETicket/components/CriteriaWrapperColRight';
import CriteriaWrapperGrid from 'src/components/demand/Demand/screens/CETicket/components/CriteriaWrapperGrid';
import CriteriaWrapperRow from 'src/components/demand/Demand/screens/CETicket/components/CriteriaWrapperRow';
import CriteriaWrapperRowButtons from 'src/components/demand/Demand/screens/CETicket/components/CriteriaWrapperRowButtons';
import Container from 'src/components/demand/Demand/screens/CETicket/components/Container';
import ContainerWrapper from 'src/components/demand/Demand/screens/CETicket/components/ContainerWrapper';
import SlipWrapper from 'src/components/demand/Demand/screens/CETicket/components/SlipWrapper';
import { MenuItem, FormControl, Input, Grid, Button } from '@material-ui/core';
import SelectCustom from 'src/components/demand/Demand/screens/CETicket/components/SelectCustom';
import Name from 'src/components/demand/Demand/screens/CETicket/components/Name';
import Required from 'src/components/demand/Demand/screens/CETicket/components/Required';
import InputUnitsWrapper from 'src/components/demand/Demand/screens/CETicket/components/InputUnitsWrapper';
import InputLabelWrapper from 'src/components/demand/Demand/screens/CETicket/components/InputLabelWrapper';
import FlexHolderColumn from 'src/components/demand/Demand/screens/CETicket/components/FlexHolderColumn';
import HolderForLine from 'src/components/demand/Demand/screens/CETicket/components/HolderForLine';
import DropDownComponent from 'src/components/demand/Demand/screens/CETicket/components/DropDownComponent';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiInput: {
      root: {
        fontSize: '14px',
        color: '#228B22',
      },
    },
    MuiMenuItem: {
      root: {
        fontSize: '12px',
        fontWeight: 'bold',
      },
    },
    MuiListItem: {
      root: {
        paddingBottom: '5px',
        paddingTop: '5px',
      },
    },
  },
});

const theme2 = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiInput: {
      root: {
        fontSize: '14px',
        color: '#62727b',
      },
    },
    MuiMenuItem: {
      root: {
        fontSize: '12px',
        fontWeight: 'bold',
      },
    },
    MuiListItem: {
      root: {
        paddingBottom: '5px',
        paddingTop: '5px',
      },
    },
  },
});

export const setImageForUpload = (setFieldValue, field) => e => {
  if (e.target.files && e.target.files[0]) {
    const file = new FileReader();
    const image = event.target.files[0];
    file.onload = fileEvent => {
      setFieldValue('profile.file', image);
      setFieldValue(field, fileEvent.target.result);
    };

    file.readAsDataURL(e.target.files[0]);
  }
};

export const toTitleCase = string => {
  if (!string) return;
  return string[0].toUpperCase() + string.substr(1);
};

export const takeInitials = name => {
  if (!name) return;
  return name
    .trim()
    .split(' ')
    .map(n => {
      return n[0].toUpperCase();
    })
    .join('');
};

export const downloadFile = (assetId, link) => onError => () => {
  axios
    .get(`${API_ROOT}/asset/${assetId}`, {
      responseType: 'blob',
    })
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);

      link.current.href = url;
      link.current.click();
    })
    .catch(onError);
};

export const geocodingAdapter = geocodedPrediction => {
  var address_components = geocodedPrediction.address_components;
  var country = '';
  var state = '';
  var county = '';
  var city = '';
  var stateCounty = '';
  for (let i = 0; i < address_components.length; i++) {
    if (
      address_components[i].types.indexOf('administrative_area_level_2') > -1
    ) {
      county = address_components[i].short_name;
    }
    if (
      address_components[i].types.indexOf('administrative_area_level_1') > -1
    ) {
      state = address_components[i].long_name;
    }
    if (address_components[i].types.indexOf('country') > -1) {
      country = address_components[i].long_name;
    }
    if (address_components[i].types.indexOf('locality') > -1) {
      city = address_components[i].long_name;
    }
  }
  if (state !== '') {
    stateCounty += state;
  }
  if (county !== '') {
    stateCounty !== ''
      ? (stateCounty = stateCounty + '/' + county)
      : (stateCounty += county);
  }
  var geocodingObject = {
    stateCounty,
    country: country,
    city: city,
  };
  return geocodingObject;
};

//#region Element factory

const createDropdown = (
  element,
  onChange,
  props,
  index,
  criteriaObjectsSelected,
  lastSelected
) => {
  return (
    <DropDownComponent element={element} onChange={onChange} index={index} />
  );
};

const createCollapseInputsRangeValue = (element, props, index) => {
  const { isEdit, changeRangeValueUnits } = props;
  var withMask =
    element.criteriaModel === 'COLLAPSE_INPUTS_RANGE_VALUE_UNIT' ? true : false; //should be coming from props
  return (
    <CriteriaGroup name={element.name} isEdit={isEdit}>
      <Grid container xs={12}>
        <Button
          style={RangeValue}
          variant="contained"
          // onClick={trigerChangeRangeValue(60)}
        >
          range/value
        </Button>
        {element.children &&
          element.children.map((item, index) => {
            return (
              <Grid
                key={`${index}-${item.id}`}
                container
                justify="center"
                spacing={8}
                alignItems="center"
                className=""
              >
                <Grid item xs={2} lg={2} className="stickToBottom">
                  <InputLabelWrapper> {item.name} </InputLabelWrapper>
                </Grid>
                {item.prefixes && (
                  <Grid item xs={2} lg={2} className="stickToBottom">
                    <InputUnitsWrapper
                      fullWidth
                      value={item.name}
                      // onChange={props.changeRangeValueUnits(item.id)}
                      inputProps={{
                        'data-custome-units-id': item.id.toString(),
                      }}
                    >
                      {item.prefixes.map((prefix, index) => {
                        return (
                          <MenuItem value={prefix} key={`${prefix}-${index}`}>
                            {prefix}
                          </MenuItem>
                        );
                      })}
                    </InputUnitsWrapper>
                  </Grid>
                )}
                <Grid item xs={item.prefixes ? 6 : 8}>
                  <FormControl fullWidth>
                    {!withMask ? (
                      <Input
                        className="text-input-center"
                        name={item.name}
                        inputProps={{
                          'data-custome-value-id': item.id.toString(),
                        }}
                      />
                    ) : (
                      <Grid
                        container
                        justify="center"
                        spacing={8}
                        alignItems="center"
                        style={{ width: '100%' }}
                      >
                        <Grid item xs={5}>
                          <Input
                            className="text-input-center"
                            name={item.name}
                            inputProps={{
                              'data-custome-value-id': item.id.toString(),
                            }}
                          />
                        </Grid>
                        <HolderForLine item xs={2}>
                          -
                        </HolderForLine>
                        <Grid item xs={5}>
                          <Input
                            className="text-input-center"
                            name={item.name}
                            inputProps={{
                              'data-custome-value-id': item.id.toString(),
                            }}
                          />
                        </Grid>
                      </Grid>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={2} lg={2} className="stickToBottom">
                  {item.units ? (
                    <InputUnitsWrapper
                      fullWidth
                      value={item.units[item.id]}
                      // onChange={props.changeRangeValueUnits(item.id)}
                      inputProps={{
                        'data-custome-units-id': item.id.toString(),
                      }}
                    >
                      {item.units.map((unit, index) => {
                        return (
                          <MenuItem value={unit} key={`${unit}-${index}`}>
                            {unit}
                          </MenuItem>
                        );
                      })}
                    </InputUnitsWrapper>
                  ) : (
                    <InputLabelWrapper>{item.unitLabel}</InputLabelWrapper>
                  )}
                </Grid>
              </Grid>
            );
          })}
      </Grid>
    </CriteriaGroup>
  );
};

const createDirect = (element, props, index) => {
  const { isEdit } = props;
  return (
    <CriteriaGroup name={element.name} isEdit={isEdit}>
      <FlexHolderColumn>
        {element.children &&
          element.children.map((item, index) => {
            return (
              item.criteriaModel.toLowerCase() === 'value' && (
                <Grid container key={`${item.name}-${index}`}>
                  <Grid
                    item
                    xs={
                      item.label && item.label !== ''
                        ? 7
                        : item.unitLabel && item.unitLabel !== ''
                        ? 6
                        : 12
                    }
                  >
                    <FormControl fullWidth>
                      <Input
                        className="text-input-center"
                        name={item.name}
                        inputProps={{
                          'data-custome-value-id': item.id.toString(),
                        }}
                      />
                    </FormControl>
                  </Grid>
                  {item.label && item.label !== '' && (
                    <Grid item xs={5}>
                      <InputLabelWrapper>{item.label}</InputLabelWrapper>
                    </Grid>
                  )}
                  {item.unitLabel && item.unitLabel !== '' && (
                    <Grid item xs={6}>
                      <InputLabelWrapper>{item.unitLabel}</InputLabelWrapper>
                    </Grid>
                  )}
                </Grid>
              )
            );
          })}
      </FlexHolderColumn>
    </CriteriaGroup>
  );
};

export const createElement = (
  item,
  index,
  onChangeDropdown,
  criteriaObjectsSelected,
  lastSelected,
  props
) => {
  switch (item.criteriaModel) {
    case 'DIRECT':
      return createDirect(item, props, index);
    default:
      return null;
  }
};
//#endregion
